let hostUrl;
let dataServiceUrl;

/** 海外数据服务：各环境统一跳转生产 SSP 看板 */
const intlDataServiceUrl = "https://ssp.360.cn/overseas/dashboard";

const isLocalDev = location.port === '8888';

if (isLocalDev) {
  // 本地 dev 走 webpack 代理，避免 console-api 未放行 :8888 的 CORS
  hostUrl = '/';
  if (location.href.indexOf('sim.openstore.360.cn') > -1) {
    dataServiceUrl = 'https://ssp-sim.360.cn/smunion/revenue/overview';
  } else if (location.href.indexOf('pre.openstore.360.cn') > -1) {
    dataServiceUrl = 'https://ssp-pre.360.cn/smunion/revenue/overview';
  } else {
    dataServiceUrl = 'https://ssp.360.cn/smunion/revenue/overview';
  }
} else if (location.href.indexOf("sim.openstore.360.cn") > -1) {
  hostUrl = "https://console-api-sim.openstore.360.cn/"
  dataServiceUrl = "https://ssp-sim.360.cn/smunion/revenue/overview"
} else if (location.href.indexOf("pre.openstore.360.cn") > -1) {
  hostUrl = "https://console-api-pre.openstore.360.cn/"
  dataServiceUrl = "https://ssp-pre.360.cn/smunion/revenue/overview"
} else {
  hostUrl = "https://console-api.openstore.360.cn/"
  dataServiceUrl = "https://ssp.360.cn/smunion/revenue/overview"
}  
 
const whiteList = [3448011916, 165349005, 3479224306, 2655065320]
 
export {
  hostUrl,
  whiteList,
  dataServiceUrl,
  intlDataServiceUrl,
}
